import CloseIcon from "components/icons/CloseIcon";
import Colors from "assets/Colors";
import Constants from "helpers/constants";

import { Button } from "antd";
import { useTranslation } from "react-i18next";
import s from "../../../../styles/Header.styles";

function Header({
  closeModal,
  section,
  setSection,
  saveButtonDisabled,
  onSave,
  showAdvancedInventory,
  type,
  updating,
  errors,
  loading,
  values,
}) {
  const error =
    !errors?.name &&
    !errors?.categoryId &&
    !errors?.price &&
    !errors?.subcategoryId &&
    !errors?.tax1;
  const errorMixAndMatch = !errors?.mixAndMatch;
  const { t } = useTranslation();

  return (
    <s.Header>
      <s.HeaderTopItems>
        <s.IconContainer onClick={() => closeModal()}>
          <CloseIcon size={13} color={Colors.primary} />
        </s.IconContainer>
        <s.TitleContainer>
          {updating
            ? t("components.InventoryItems.AddItem.Header.editArticle")
            : t("components.InventoryItems.AddItem.Header.addArticle")}
        </s.TitleContainer>
        <Button
          type="text"
          disabled={saveButtonDisabled}
          loading={loading}
          onClick={() => !saveButtonDisabled && onSave()}
        >
          {t("actions.save")}
        </Button>
      </s.HeaderTopItems>

      <s.HeaderSecondLineContainer>
        <s.MenuTitleContainer
          style={{
            marginRight: "37px",
            color: !error && Colors.notification_failed,
            borderColor: !error && Colors.notification_failed,
          }}
          selected={section === Constants.GENERAL_SECTION}
          onClick={() => setSection(Constants.GENERAL_SECTION)}
        >
          {t("components.InventoryItems.AddItem.Header.general")}
        </s.MenuTitleContainer>
        {type === "mix&match" && (
          <s.MenuTitleContainer
            style={{
              marginRight: "37px",
              color: !errorMixAndMatch && Colors.notification_failed,
              borderColor: !errorMixAndMatch && Colors.notification_failed,
            }}
            selected={section === Constants.MIX_AND_MATCH_SECTION}
            onClick={() => setSection(Constants.MIX_AND_MATCH_SECTION)}
          >
            {t("components.InventoryItems.AddItem.Header.mixAndMatch")}
          </s.MenuTitleContainer>
        )}

        <s.MenuTitleContainer
          style={{ marginRight: "37px" }}
          selected={section === Constants.INVENTORY_SECTION}
          onClick={() => setSection(Constants.INVENTORY_SECTION)}
        >
          {t("components.InventoryItems.AddItem.Header.inventory")}
        </s.MenuTitleContainer>

        {values.variantId && (
          <s.MenuTitleContainer
            style={{ marginRight: "37px" }}
            selected={section === Constants.PRICES_PER_VARIANT_SECTION}
            onClick={() => setSection(Constants.PRICES_PER_VARIANT_SECTION)}
          >
            {t(
              "components.InventoryItems.AddItem.PricesPerVariant.pricesPerVariant"
            )}
          </s.MenuTitleContainer>
        )}
        {showAdvancedInventory === "variant" && (
          <s.MenuTitleContainer
            style={{ marginRight: "37px" }}
            selected={section === Constants.ADVANCED_INVENTORY_SECTION}
            onClick={() => setSection(Constants.ADVANCED_INVENTORY_SECTION)}
          >
            {t("components.InventoryItems.AddItem.Header.advancedInventory")}
          </s.MenuTitleContainer>
        )}
        <s.MenuTitleContainer
          selected={section === Constants.MODIFIERS_SECTION}
          onClick={() => setSection(Constants.MODIFIERS_SECTION)}
        >
          {t("components.InventoryItems.AddItem.Header.modifiers")}
        </s.MenuTitleContainer>
      </s.HeaderSecondLineContainer>
    </s.Header>
  );
}

export default Header;
